import { cx } from "@emotion/css";
import { ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createDialogContentWrapperStyles } from "../helpers/createDialogContentWrapperStyles";

interface DialogContentWrapperProps {
  children?: ReactNode;
  className?: string;
}

export function DialogContentWrapper({
  children,
  className,
}: DialogContentWrapperProps) {
  const classes = createDialogContentWrapperStyles(useTheme());

  return (
    <div className={cx(classes.contentWrapper, className)}>{children}</div>
  );
}
